import * as S from './style';

interface TextareaProps {
	value: string;
}
const Textarea = ({ value }: TextareaProps) => <S.Container readOnly value={value} />;
export default Textarea;
